export default __webpack_public_path__ + "static/media/group-7356.25272215.svg";